import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';

@Component({
  selector: 'app-tax-invoice-list',
  templateUrl: './tax-invoice-list.component.html',
  styleUrls: ['./tax-invoice-list.component.scss']
})
export class TaxInvoiceListComponent implements OnInit {
  user:any={}
  json: any=[];
  clients: any = {}
  constructor(private router: Router, 
    public httpService: HttpServiceService, public alertService: AlertService,
    public util:UtilService,
    public loaderService: LoaderService) {
      this.user = JSON.parse(localStorage.getItem('AlluserData'))
      console.log(this.user)
  }

  loadData(){
    this.loaderService.showLoader('Fetching Please wait ..').then(()=>{
      try{
        this.httpService.getApi('TaxInvoice/getAll').subscribe(async(res: any) => {
          console.log(res)
          res.sucess
          this.json = res.success.taxinvoice;
          this.json.forEach(element => {
            element['invoices'] = JSON.parse(element['invoices'])
          });
          console.log(this.json)
          await this.getclient()
          //this.json['invoices']= JSON.parse(res.success.taxInvoice['invoices'])
          console.log(this.json)
          this.loaderService.hideLoader();
         },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });
      }catch(e){
        this.loaderService.hideLoader();
      }
   
    });
  }
  clientData:any = {}
  async ngOnInit() {
   
    this.clientData =JSON.parse(localStorage.getItem('AlluserData'))
    
    if(this.user.isAdmin == 0){
      this.loaderService.showLoader('Fetching Please wait ..').then(()=>{
        try{
          this.httpService.postApi({client:this.user.id},'TaxInvoice/getInvoiceByClient/' +this.user.id ).subscribe(async(res: any) => {
              console.log(res)
            if (res.success) {
              console.log(res)
              this.json = res.success.taxinvoice;
              this.json.forEach(element => {
                element['invoices'] = JSON.parse(element['invoices'])
              });
               console.log(this.json)
               await this.getclient()
            }
            this.loaderService.hideLoader();
           },(err)=>{
            
            this.loaderService.hideLoader();
            this.alertService.presentNetworkAlert();
           });
        }catch(e){
          this.loaderService.hideLoader();
        }
     
      });
    }else {
    
      this.loadData();
    }
  }
  add() {
    this.router.navigate(['/taxInvoice-add'])
  }

  details(data) {
    localStorage.setItem('taxInvoiceDetails', JSON.stringify(data));
    this.router.navigate(['/taxInvoice-details'])
  }

  getclient()
  {
    console.log("clients")
    return new Promise(resolve => {
      this.json.forEach(element => {
          this.httpService.postApi(element['client'], 'Client/getbyid/' + element['client']).subscribe((res: any) => {
            if (res.success) {
              console.log(res)
               this.clients[element['client']] = res.success.client
               console.log(this.clients)
            }
          });
      })
      resolve(1)      
    })
  }

}
